import React, {useState} from 'react';
import {FaArrowUp} from 'react-icons/fa';
import './ScrollButton2.css';


const ScrollButton2 = () =>{

    const [showScroll, setShowScroll] = useState(false)

    const checkScrollTop = () => {
        if (!showScroll && window.pageYOffset > 400) {
            setShowScroll(true)
        } else if (showScroll && window.pageYOffset <= 400) {
            setShowScroll(false)
        }
    };

    const scrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    window.addEventListener('scroll', checkScrollTop)

    return (
        <FaArrowUp className="scrollTop" onClick={scrollTop} style={{ border: '1px', display: showScroll ? 'flex' : 'none' }} />
    );
}

export default ScrollButton2;